import {  GraphQLTypes, InputType, Selector } from '@zeus/index';
import { typedGql } from '@zeus/typedDocumentNode';
import { scalars } from '~/gql/utils/scalars';


const avatarSelector = Selector('Avatar')({
    id: true,
    fileName : true,
})

export const GQL_AVATARS = typedGql('query', { scalars })({
    getAvatars: {
        ...avatarSelector
    },
});

export type StoredAvatar = InputType<GraphQLTypes['Avatar'], typeof avatarSelector>;